import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import VideoDialogMain from "./VideoDialogMain";
import RepeatsmartFinalCutImage from "../../Assets/Icons/Repeatsmart_Final_Cut.png";
import QuickRepeatsmartImage from "../../Assets/Icons/Quick_Repeatsmart_Demo-Image.png";
import PatientImage from "../../Assets/Icons/PatientImage.png";
import HowToCommonCard from "./HowToCommonCard";

const useStyle = makeStyles((theme) => ({
  rsHowToMain: {
    // background: "white",
    // padding: "20px",
    display: "flex",
    justifyContent: "center",
    maxHeight: "calc(100vh - 150px) !important",
    overflowY: "scroll",
    [theme.breakpoints.down(768)]: {
      marginTop: "20px !important",
    },
  },
  rsGettingHowto: {
    // background: "white",
    width: "90%",
    height: "fit-content",
    padding: "10px",
    // display: "inline-block",
    justifyContent: "center",
    display: "grid",
    gridTemplateColumns: "repeat(3, 2fr)",
    [theme.breakpoints.down(1690)]: {
      gridTemplateColumns: "repeat(2, 2fr)",
    },
    [theme.breakpoints.down(1200)]: {
      width: "100%",
    },
    [theme.breakpoints.down(768)]: {
      gridTemplateColumns: "repeat(1, 2fr)",
    },
  },
  rsRowColor: {
    width: "450px",
    height: "300px",
    borderRadius: "10px",
    backgroundColor: "white",
    display: "block",
    padding: "30px",
    paddingLeft: "30px",
    margin: "10px",
    paddingRight: "30px",
    justifyContent: "space-between",
    alignItems: "center",
    position: "sticky",
    "&>span": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      "&>img": {
        width: "100%",
        display: "flex",
      },
      "&>svg": {
        zIndex: "2",
        position: "absolute",
        width: "50px",
        height: "50px",
      },
    },
    "&>div": {
      "&>button": {
        marginTop: "10px",
        borderRadius: "40px",
        height: "40px",
        whiteSpace: "nowrap",
      },
      "&>h3": {
        marginTop: "15px",
        fontSize: "22px",
        fontWeight: "400",
        // color: "black",
        cursor: "pointer",
        width: "fit-content",
        "&:hover": {
          textDecoration: "underline",
          color: "rgb(123, 192, 68)",
        },
      },
    },
    [theme.breakpoints.down(1066)]: {
      width: "94%",
      height: "350px",
    },
  },
  GettingBoxMain: {
    display: "flex",
    justifyContent: "center",
  },
}));

const HowToMain = () => {
  const classes = useStyle();
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [linkvideo, setLinkvideo] = useState("");
  const [title, setTitle] = useState("");
  return (
    <Box className={classes.rsHowToMain}>
      <Box className={classes.rsGettingHowto}>
        <HowToCommonCard
          setVideoDialogOpen={setVideoDialogOpen}
          setLinkvideo={setLinkvideo}
          setTitle={setTitle}
          Link="https://www.youtube.com/embed/7quJ0-mGuDU?si=QCKSbyg6Mv6cuiSB"
          titlename={"Quick Repeatsmart How To"}
          img={QuickRepeatsmartImage}
        />
        <HowToCommonCard
          setVideoDialogOpen={setVideoDialogOpen}
          setLinkvideo={setLinkvideo}
          setTitle={setTitle}
          Link="https://www.youtube.com/embed/7YRSKu1x7MI?si=G0pTIHkc6kLg4brR"
          titlename={"Full Repeatsmart Explainer"}
          img={RepeatsmartFinalCutImage}
        />
        <HowToCommonCard
          setVideoDialogOpen={setVideoDialogOpen}
          setLinkvideo={setLinkvideo}
          setTitle={setTitle}
          Link="https://www.loom.com/embed/eac968353cd6457f8cfdce5fa4102d30"
          titlename={"PMR Import"}
          img={PatientImage}
        />
      </Box>
      <VideoDialogMain
        open={videoDialogOpen}
        setOpen={setVideoDialogOpen}
        link={linkvideo}
        title={title}
      />
    </Box>
  );
};

export default HowToMain;
